import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CourseService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/kampuscourses", data);
    return response.data;
  },
  createGrp: async (data) => {
    const response = await apiService.post("/coursesgroup", data);
    return response.data;
  },

  checkSlug: async (data) => {
    const response = await apiService.post("/kampuscourses/check-slug", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/kampuscourses/${id}`,
        updatedData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  updateCourse: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/kampuscourses/update-course/${id}`,
        updatedData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  updateGrp: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/coursesgroup/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({ search = "", courseGroupId, page = 1, pageSize = 12 }) => {
    const params = new URLSearchParams({
      ...(search && { search }),
      ...(courseGroupId && { courseGroupId }),

      pageNumber: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(
      `/kampuscourses?${params.toString()}`,
    );
    return response.data;
  },
  getGrpList: async () => {
    const response = await apiService.get(`/coursesgroup`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/kampuscourses/${id}/full`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/kampuscourses/${id}`);
    return response.data;
  },
  deleteGrp: async (id) => {
    const response = await apiService.delete(`/coursesgroup/${id}`);
    return response.data;
  },
  updatePublishStatus: async (id, isPublished) => {
    const response = await apiService.put(
      `/kampuscourses/update-publish-id/${id}?isPublished=${isPublished}`,
    );
    return response.data;
  },
};

export default CourseService;
